import React from 'react';
import {usePaymentRecurringContext} from '../../contexts/PaymentRecurringContext';
import InputCurrency from '../InputCurrency';

const FieldCurrencyR = () => {
  const {currencyOptions} = usePaymentRecurringContext();

  return <InputCurrency currencyOptions={currencyOptions} isDisabled={true}/>
};

export default FieldCurrencyR;
